import React from "react";
import { AuthProvider } from "../context/authContext";
import Providers from "./Providers";
import { Provider } from "react-redux";
import store from "../context/redux/configureStore";

const RootComponent = (props) => {
  return (
    <AuthProvider>
      <Provider store={store}>
        <Providers />
      </Provider>
    </AuthProvider>
  );
};

export default RootComponent;
